import { useMutation } from "react-query";
import { createDischargePlanning, updateDischargePlanning } from "api/clinicalManagement";
import { useGlobalToast } from "components/GlobalToastProvider";

const useSaveDischargePlanning = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({
      clientId,
      recordId,
      payload,
    }: {
      clientId: number;
      recordId?: number;
      payload: Record<string, any>;
    }) =>
      recordId
        ? updateDischargePlanning(recordId, payload)
        : createDischargePlanning(clientId, payload),
    {
      onError: (error, variables, context) => {
        showToast({
          message: "Whoops! Something went wrong while saving discharge planning.",
          errorState: true,
        });
        onError(error, variables, context);
      },
      ...otherOptions,
    }
  );

  return {
    saveDischargePlanningMutation: mutate,
    isSaveDischargePlanningLoading: isLoading,
    ...rest,
  };
};

export default useSaveDischargePlanning;
